module.exports = __webpack_public_path__ + "static/Q1Answer3_Green_JasonDent-f3b6f114678e6ef874f358f989fb2959.jpg";